import { useContext } from 'react';
import { MeContext } from '../../../context/MeContext';

export const useOnboardingSurveyGate = (): boolean => {
  const meCtx = useContext(MeContext) as {
    state: {
      onboardingQuestionnaireEnabled: boolean | null;
      onboardingQuestionnaireCompleted: boolean | null;
    };
  };
  const { onboardingQuestionnaireEnabled, onboardingQuestionnaireCompleted } =
    meCtx.state;

  return Boolean(
    onboardingQuestionnaireEnabled && !onboardingQuestionnaireCompleted
  );
};
